import { firestore } from "../../firebase.config";

export const getCounter = async (type) => {
    const delta = type === "order" ? 7 : type === "quote" ? 5 : 3;

    const docRef = firestore.collection("counters").doc(type);
    const number = await docRef.get().then(async docSnap => {

        if(!docSnap.exists){
            console.log("no doc")
            return 0;
        }else{
            const newNumber = docSnap.data().number + delta;
            console.log("newNumber");
        
            await docRef.update({number: newNumber});
        
            return docSnap.data().number;
        }
    })
    
    return number;

}